// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"42c7114b","149":"e61958f9","196":"00820646","397":"ad407cfd","528":"c33403a8","673":"fe92db91","749":"2f2dd7a6","845":"17b50c20","944":"a35fac5f"}[chunkId] + ".chunk.js";
};